// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:71em){.advantages__container[data-v-1bff5a84]{padding:0!important}}.advantages__content[data-v-1bff5a84]{display:grid;grid-template-columns:minmax(0,1fr);grid-gap:2.5rem 2rem;gap:2.5rem 2rem}@media only screen and (min-width:600px){.advantages__content[data-v-1bff5a84]{grid-template-columns:repeat(3,minmax(0,1fr))}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
